import type { Gender } from 'config/enums';
import type { CallType } from 'features/call/call-base/enums';
import {
  RelayCallState,
  RelayConnectionTypes,
  TerminationType,
} from 'features/call/call-base/enums';

export interface CallState {
  id: number;
  languageCode: string;
  callerName: string;
  genderRequest: Gender | null;
  callType: CallType | null;
  callTakenTime: string;
  isDeafToHearing: boolean;
  relayCallState: RelayCallState;
  isCanBeTransferred: boolean;
  isHearingCallerIdBlocked: boolean;
  registrationType: number | null;
  registrationFailureCode: number | null;
  coreServicesUserId: number | null;
  coreRingGroupOwnerUserId: number | null;
  isAutoCompleteEnabled: boolean;
  wasCallAbandoned: boolean;
  callerConnectionType: RelayConnectionTypes;
  terminationType: TerminationType;
  totalInterpretTime: number;
  sipCallId: string;
  sipHeaderFrom: string;
  lastCallId?: number;
  endpointMacAddress: string;
  peerUserAgent?: string;
  calleeConnectionString?: string;
  hearingPhoneExtension: string;
  connectionStateHistoryCount: number;
  DeafIpTraceback: string;
  replacedCallOwnerUserId: number | null;
  replacedCallOwnerName: string | null;
}

export const initialCallState: CallState = {
  id: 0,
  languageCode: '',
  callerName: '',
  genderRequest: null,
  callType: null,
  callTakenTime: '',
  calleeConnectionString: '',
  hearingPhoneExtension: '',
  isDeafToHearing: true,
  relayCallState: RelayCallState.Invalid,
  isCanBeTransferred: true,
  isHearingCallerIdBlocked: false,
  registrationType: null,
  registrationFailureCode: null,
  coreServicesUserId: null,
  coreRingGroupOwnerUserId: null,
  isAutoCompleteEnabled: true,
  wasCallAbandoned: false,
  callerConnectionType: RelayConnectionTypes.PhoneNum,
  terminationType: TerminationType.Normal,
  totalInterpretTime: 0,
  sipCallId: '',
  sipHeaderFrom: '',
  endpointMacAddress: '',
  peerUserAgent: '',
  connectionStateHistoryCount: 0,
  DeafIpTraceback: '',
  replacedCallOwnerUserId: null,
  replacedCallOwnerName: null,
};
